import { createBrowserHistory, createMemoryHistory } from 'history';

const DEBUG = false;

// When the workspace-prefix flag is on, the browser history uses the workspace
// path as its basename so all history.push('/clients') calls produce
// /w/<subdomain>/clients without touching any of the ~300 call sites.
function getWorkspaceBasename(): string {
  if (typeof window === 'undefined') return '';
  const app = (window as any).App;
  if (!app?.flags?.EnableDeepLinkWorkspacePrefix) return '';
  // Client portal (hostname-based) must never carry the prefix.
  if (app?.portalConfig?.viewMode === 'client') return '';
  const subdomain: string | undefined = app?.portalConfig?.subdomain;
  if (!subdomain) return '';
  return `/w/${subdomain}`;
}

// I had a tricky problem trying to figure out what was causing a redirection.
// This function should help if anyone has this issue in the future.
function getHistory(
  debug: boolean,
):
  | ReturnType<typeof createBrowserHistory>
  | ReturnType<typeof createMemoryHistory> {
  if (!debug) {
    return process.env.BROWSER
      ? createBrowserHistory({ basename: getWorkspaceBasename() })
      : createMemoryHistory();
  }

  if (process.env.BROWSER) {
    const browserHistory = createBrowserHistory({
      basename: getWorkspaceBasename(),
    });
    type PushParams = Parameters<typeof browserHistory.push>;
    type ReplaceParams = Parameters<typeof browserHistory.replace>;
    // Sorry to use any here, but it's just for debugging purposes.
    const result: any = {
      ...browserHistory,
      push: (...args: PushParams) => {
        // eslint-disable-next-line no-console
        console.log('historyDebugger.push', ...args);
        // eslint-disable-next-line no-console
        console.trace('historyDebugger.push');
        browserHistory.push(...args);
      },
      replace: (...args: ReplaceParams) => {
        // eslint-disable-next-line no-console
        console.log('historyDebugger.replace', ...args);
        // eslint-disable-next-line no-console
        console.trace('historyDebugger.replace');
        browserHistory.replace(...args);
      },
    };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return result;
  }

  return createMemoryHistory();
}

export default getHistory(DEBUG);
